import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./TeamSlider.css"; // The updated CSS is below
import founderImg from "../../assets/our-team/founder.png";
import vinduJiImg from "../../assets/our-team/vindu-ji.png";
import coreTeamImg from "../../assets/our-team/core-team.png";


// 💡 Simplified data structure: just the image URLs
const teamSlides = [
  {
    id: 1,
    image: founderImg, // 👈 Slide 1: Founder
    alt: "Company Founder Profile",
  },
  {
    id: 2,
    image: vinduJiImg, // 👈 Slide 2: Brand Ambassador
    alt: "Brand Ambassador Profile",
  },
  {
    id: 3,
    image: coreTeamImg, // 👈 Slide 3: Team Members
    alt: "Our Core Team",
  },
];

const TeamSlider = () => {
  // 💡 Configuration settings for the single-image slider
  const settings = {
    dots: true, // Show navigation dots
    infinite: true, // Loop the slides
    speed: 500, // Transition speed
    slidesToShow: 1, // 💡 Show only one slide at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true, // Show next/prev arrows
    pauseOnHover: true, // Pause autoplay when mouse hovers
    // You can remove the 'responsive' block since slidesToShow is always 1,
    // but the CSS will ensure it is responsive.
  };

  return (
    <div className="team-slider-container">
      <h2 className="slider-title">Meet Our Team</h2>
      <Slider {...settings}>
        {teamSlides.map((slide) => (
          // 💡 The slide only contains the image
          <div key={slide.id} className="team-slide-wrapper">
            <img 
              src={slide.image} 
              alt={slide.alt} 
              className="team-slide-image" 
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TeamSlider;